<script>
import Question from './Question';

export default {
  name: 'QuestionList',
  components: {
    Question,
  },
  props: {
    categoryId: {
      type: Number,
      required: false,
      default: null,
    },
    questions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  created() {
    this.localDisabled = this.disabled;
  },
  methods: {
    onDelete(questionId) {
      let i = 0;

      while (i < this.questions.length) {
        if (this.questions[i].id === questionId) break;
        else i += 1;
      }
      this.questions.splice(i, 1);
    },
    onNewQuestion() {
      let maxQuestionOrder;

      if (this.questions && this.questions.length > 0) {
        maxQuestionOrder = Math.max(...this.questions.map(it => it.orderNumber));
      } else {
        maxQuestionOrder = 0;
      }

      this.questions.push({
        orderNumber: maxQuestionOrder + 1,
        answers: [{ orderNumber: 1 }],
      });
    },
  },
};
</script>

<template>
  <div>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <div v-for="question in questions" :key="question.id">
        <v-layout row wrap>
          <v-flex md12>
            <Question :question="question" @delete="onDelete" />
          </v-flex>
        </v-layout>
      </div>
      <!-- TODO: Format Button. Add also a button to the toolbar for better accessability. -->
      <v-layout row wrap>
        <v-flex xs5 md5 py-0/>
        <v-flex xs5 md5 py-0>
          <v-btn @click="onNewQuestion" slot="activator" small>
            <span>Neue Frage</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
